import { Table, TableProps } from 'antd';
import { formatCurrency, formatNumber } from '../../../../../common/utils';
import { ReligiousTransparencyAnalysesData } from '../ReligiousTransparencyAnalysis';

const CostTokenDetails: React.FC<{
  selectReligiousTransparencyData:
    | ReligiousTransparencyAnalysesData
    | undefined;
}> = ({ selectReligiousTransparencyData }) => {
  const columns: TableProps<ReligiousTransparencyAnalysesData>['columns'] = [
    {
      title: 'Input Price',
      dataIndex: 'inputPrice',
      key: 'inputPrice',
      width: 100,
      render: (value) => formatCurrency({ value: value ?? 0 }),
    },
    {
      title: 'Output Price',
      dataIndex: 'outputPrice',
      key: 'outputPrice',
      width: 100,
      render: (value) => formatCurrency({ value: value ?? 0 }),
    },
    {
      title: 'Total Price',
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      width: 100,
      render: (value) => formatCurrency({ value: value ?? 0 }),
    },

    {
      title: 'Input Tokens',
      dataIndex: 'inputTokens',
      key: 'inputTokens',
      width: 100,
      render: (value: string) => formatNumber(+(value ?? 0)),
    },
    {
      title: 'Output Tokens',
      dataIndex: 'outputTokens',
      key: 'outputTokens',
      width: 100,
      render: (value: string) => formatNumber(+(value ?? 0)),
    },
    {
      title: 'Total Tokens',
      dataIndex: 'totalTokens',
      key: 'totalTokens',
      width: 100,
      render: (value: string) => formatNumber(+(value ?? 0)),
    },
  ];

  const dataSource: ReligiousTransparencyAnalysesData[] = [
    {
      ...selectReligiousTransparencyData,
      documentId: selectReligiousTransparencyData?.documentId ?? '',
    },
  ];

  return (
    <div>
      <div className="d-flex mt-16 full-width">
        <Table<ReligiousTransparencyAnalysesData>
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          scroll={{
            x: 'max-content',
          }}
        />
      </div>{' '}
    </div>
  );
};

export default CostTokenDetails;
